<template>
  <div class="row">

    <div class="col-md-3">
      <el-select v-model="this.selectedSourceLanguage">
        <el-option
          v-for="language in languages"
          :key="language.code"
          :label="language.code"
          :value="language.code"
        >
        <span style="float: left">{{ language.code }}</span>
        <span
          style="
          float: right;
          color: var(--el-text-color-secondary);
          font-size: 13px;
          "
          >{{ language.name }}</span
        >
        </el-option>
      </el-select>
    </div>

    <div class="col-md-3">
      <el-select v-model="this.selectedTargetLanguage">
        <el-option
          v-for="language in languages"
          :key="language.code"
          :label="language.code"
          :value="language.code"
        >
        <span style="float: left">{{ language.code }}</span>
        <span
          style="
          float: right;
          color: var(--el-text-color-secondary);
          font-size: 13px;
          "
          >{{ language.name }}</span
        >
        </el-option>
      </el-select>
    </div>

    <div class="col-md-3">
      <el-select v-model="this.selectedAimodel">
        <el-option
          v-for="aimodel in aimodels"
          :key="aimodel.name"
          :label="aimodel.name"
          :value="aimodel.name"
        >
        </el-option>
      </el-select>
    </div>

    <div class="col-md-3">
      <el-select v-model="this.selectedGlossary">
        <el-option
          v-for="glossary in glossaries"
          :key="glossary.name"
          :label="glossary.name"
          :value="glossary.name"
        >
        </el-option>
      </el-select>
    </div>

  </div>
</template>

<script>
export default {
  name: "TranslationOptions",
  props: {
    languages: {
      type: Array,
      required: true,
    },
    aimodels: {
      type: Array,
      required: true,
    },
    glossaries: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedSrcLanguage: "英",
      selectedTrgLanguage: "日",
      selectedAimodel: "",
      selectedGlossary: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col-md-3 {
  flex: 0 0 25%;
  max-width: 25%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
</style>